var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import { MapState } from 'store/decorators';
import { validationMixin } from 'vuelidate';
import FormMixin from 'components/Forms/FormMixin';
import CheckboxElement from 'components/Elements/Checkbox.vue';
import DateSingleElement from 'components/Elements/DateSingle.vue';
import InputElement from 'components/Elements/Input.vue';
import TitleElement from 'components/Elements/Title.vue';
import FilesUploadSection from 'components/Forms/FilesUploadSection.vue';
import PaymentValidationService from 'services/AirBaltic/Forms/PaymentValidation';
import UuidUtilsService from 'utils/UUID_Utils';
import FlightUtils from 'utils/FlightUtils';
var Errors = function () {
    return import(/* webpackChunkName: "element-errors" */ 'components/Elements/Errors.vue');
};
var PaymentBaseForm = /** @class */ (function (_super) {
    __extends(PaymentBaseForm, _super);
    function PaymentBaseForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PAX_FLIGHT_LIMIT = 9;
        _this.titleMap = { MS: 'Ms', MR: 'Mr' };
        _this.form = {
            passengers: [],
            contactFirstName: '',
            contactLastName: '',
            email: '',
            message: '',
            title: ''
        };
        _this.unsubscribeAction = function () { return null; };
        return _this;
    }
    PaymentBaseForm.prototype.mounted = function () {
        var _this = this;
        this.$store.commit('bookingValidation/files/setMaxLength', 99);
        this.$store.commit('bookingValidation/files/setCheckEachFileSize', false);
        this.unsubscribeAction = this.$store.subscribeAction(function (_a) {
            var type = _a.type;
            if (type !== 'bookingValidation/validateBookingCancelation') {
                return;
            }
            _this.$v.form.$touch();
            if (_this.$v.form.$anyError) {
                _this.$emit('error');
                return;
            }
            _this.$emit('success');
        });
        this.$store.commit('bookingValidation/files/setMaxLength', 99);
        if (this.isDefaultForm) {
            this.form.passengers = [this.createEmptyPax()];
            return;
        }
        this.setContactInfo();
    };
    PaymentBaseForm.prototype.beforeDestroy = function () {
        this.unsubscribeAction();
    };
    Object.defineProperty(PaymentBaseForm.prototype, "pnrData", {
        get: function () {
            return this.bookingValidation.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentBaseForm.prototype, "mappedPassengerData", {
        get: function () {
            var _this = this;
            if (this.isDefaultForm || !this.pnrData.passengers.length) {
                return [];
            }
            return this.pnrData.passengers.map(function (_a) {
                var givenName = _a.givenName, surname = _a.surname;
                var _b = _this.getNameAndTitle(givenName), name = _b.name, title = _b.title;
                return {
                    firstName: name,
                    flights: [],
                    id: UuidUtilsService.create_UUID(),
                    lastName: surname,
                    title: _this.titleMap[title] || ''
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentBaseForm.prototype, "segments", {
        get: function () {
            var _this = this;
            if (this.isDefaultForm || !this.pnrData.segments.length) {
                return [];
            }
            return this.pnrData.segments.map(function (segment) {
                var flightDate = moment(segment.departureDate).format('DD / MM / YYYY');
                var formattedDate = moment(segment.departureDate).format('LL');
                var flightNumber = "".concat(segment.carrier).concat(segment.number);
                return {
                    flightNumber: flightNumber,
                    flightDate: flightDate,
                    originLabel: _this.getDirection(segment.origin),
                    destinLabel: _this.getDirection(segment.destin),
                    formattedDate: formattedDate
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    PaymentBaseForm.prototype.getDirection = function (code) {
        var location = Object.values(this.bookingValidation.origDestData).find(function (obj) { return obj.code === code; });
        if (typeof location === "undefined") {
            return code;
        }
        return "".concat(location.apt, " (").concat(location.code, ")");
    };
    Object.defineProperty(PaymentBaseForm.prototype, "isDefaultForm", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.pnrData) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.group)
                || FlightUtils.isCharterFlight(this.pnrData.segments)
                || this.$props.isDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentBaseForm.prototype, "hasPassengerSelectionError", {
        get: function () {
            var _a, _b;
            if (!((_a = this.$v.form.passengers) === null || _a === void 0 ? void 0 : _a.$error)) {
                return false;
            }
            return !((_b = this.$v.form.passengers) === null || _b === void 0 ? void 0 : _b.required);
        },
        enumerable: false,
        configurable: true
    });
    PaymentBaseForm.prototype.updateForm = function () {
        this.$emit('input', this.form);
    };
    PaymentBaseForm.prototype.hasError = function (field) {
        return this.$_formMixin_hasError(this.$v.form, field);
    };
    PaymentBaseForm.prototype.getErrorMsg = function (field) {
        return this.$_formMixin_errorMsg(this.$v.form, PaymentValidationService.errorMessages, field);
    };
    PaymentBaseForm.prototype.hasFlightSelectionError = function (paxIndex) {
        var _a, _b, _c, _d, _e;
        if (!((_a = this.$v.form.passengers) === null || _a === void 0 ? void 0 : _a.required)) {
            return false;
        }
        if (!((_b = this.$v.form.passengers) === null || _b === void 0 ? void 0 : _b.$each) ||
            !((_c = this.$v.form.passengers.$each[paxIndex]) === null || _c === void 0 ? void 0 : _c.$error)) {
            return false;
        }
        return !((_e = (_d = this.$v.form.passengers.$each[paxIndex]) === null || _d === void 0 ? void 0 : _d.flights) === null || _e === void 0 ? void 0 : _e.required) || false;
    };
    PaymentBaseForm.prototype.getErrorPath = function (paxIndex, flightIndex) {
        var _a, _b, _c, _d;
        return !!flightIndex || flightIndex === 0
            ? (_c = (_b = (_a = this.$v.form.passengers) === null || _a === void 0 ? void 0 : _a.$each[paxIndex]) === null || _b === void 0 ? void 0 : _b.flights) === null || _c === void 0 ? void 0 : _c.$each[flightIndex]
            : (_d = this.$v.form.passengers) === null || _d === void 0 ? void 0 : _d.$each[paxIndex];
    };
    PaymentBaseForm.prototype.hasPassengerOrFlightErrors = function (field, paxIndex, flightIndex) {
        var path = this.getErrorPath(paxIndex, flightIndex);
        if (!path) {
            return false;
        }
        return path[field].$error;
    };
    PaymentBaseForm.prototype.getPassengerOrFlightErrorMsg = function (field, paxIndex, flightIndex) {
        var path = this.getErrorPath(paxIndex, flightIndex);
        if (!path) {
            return '';
        }
        return this.$_formMixin_errorMsg(path, PaymentValidationService.errorMessages, field);
    };
    PaymentBaseForm.prototype.updateTitle = function (title) {
        this.form.title = title;
        this.updateForm();
    };
    PaymentBaseForm.prototype.isPassengerSelected = function (passenger) {
        return this.form.passengers.some(function (_a) {
            var id = _a.id;
            return id === passenger.id;
        });
    };
    PaymentBaseForm.prototype.addEmptyPassenger = function () {
        this.form.passengers = __spreadArray(__spreadArray([], this.form.passengers, true), [this.createEmptyPax()], false);
    };
    PaymentBaseForm.prototype.removePassenger = function (passengerId) {
        this.form.passengers = this.form.passengers.filter(function (_a) {
            var id = _a.id;
            return id !== passengerId;
        });
    };
    PaymentBaseForm.prototype.hasMultipleFlights = function (passengerId) {
        var _a, _b;
        var passenger = (_a = this.form.passengers) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
            var id = _a.id;
            return id === passengerId;
        });
        if (!((_b = passenger === null || passenger === void 0 ? void 0 : passenger.flights) === null || _b === void 0 ? void 0 : _b.length)) {
            return false;
        }
        return passenger.flights.length > 1;
    };
    PaymentBaseForm.prototype.removeFlight = function (passengerId) {
        var _a, _b;
        var passenger = (_a = this.form.passengers) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
            var id = _a.id;
            return id === passengerId;
        });
        if (!((_b = passenger === null || passenger === void 0 ? void 0 : passenger.flights) === null || _b === void 0 ? void 0 : _b.length) || (passenger === null || passenger === void 0 ? void 0 : passenger.flights.length) <= 1) {
            return;
        }
        passenger.flights.pop();
    };
    PaymentBaseForm.prototype.updatePassenger = function (isSelected, passenger) {
        this.form.passengers = isSelected
            ? __spreadArray(__spreadArray([], this.form.passengers, true), [passenger], false) : this.form.passengers.filter(function (_a) {
            var id = _a.id;
            return id !== passenger.id;
        });
        this.updateForm();
    };
    PaymentBaseForm.prototype.isFlightSelected = function (currentFlightNumber, passengerId) {
        var pax = this.form.passengers.find(function (_a) {
            var id = _a.id;
            return id === passengerId;
        });
        if (!pax) {
            return false;
        }
        return pax.flights.some(function (_a) {
            var flightNumber = _a.flightNumber;
            return flightNumber === currentFlightNumber;
        });
    };
    PaymentBaseForm.prototype.setFlight = function (isSelected, passengerId, flight) {
        this.form.passengers = this.form.passengers.map(function (passenger) {
            if (passenger.id !== passengerId) {
                return passenger;
            }
            var flights = isSelected
                ? __spreadArray(__spreadArray([], passenger.flights, true), [flight], false) : passenger.flights.filter(function (_a) {
                var flightNumber = _a.flightNumber;
                return flightNumber !== flight.flightNumber;
            });
            return __assign(__assign({}, passenger), { flights: flights });
        });
        this.updateForm();
    };
    PaymentBaseForm.prototype.addFlight = function (passengerId) {
        this.form.passengers = this.form.passengers.map(function (passenger) {
            if (passengerId !== passenger.id) {
                return passenger;
            }
            return __assign(__assign({}, passenger), { flights: __spreadArray(__spreadArray([], passenger.flights, true), [
                    { flightNumber: '', flightDate: '', originLabel: '', destinLabel: '' }
                ], false) });
        });
    };
    PaymentBaseForm.prototype.getNameAndTitle = function (givenName) {
        if (!givenName) {
            return { name: '', title: '' };
        }
        var _a = givenName.split(' '), name = _a[0], title = _a[1];
        return { name: name, title: title };
    };
    PaymentBaseForm.prototype.setContactInfo = function () {
        if (!this.pnrData.passengers.length) {
            return;
        }
        var pax = this.pnrData.passengers.find(function (_a) {
            var givenName = _a.givenName, surname = _a.surname;
            return !!givenName && !!surname;
        });
        if (!pax) {
            return;
        }
        var _a = this.getNameAndTitle(pax.givenName), name = _a.name, title = _a.title;
        this.form.contactFirstName = name;
        this.form.contactLastName = pax.surname;
        this.form.title = this.titleMap[title];
    };
    PaymentBaseForm.prototype.createEmptyPax = function () {
        return {
            firstName: '',
            lastName: '',
            title: '',
            id: UuidUtilsService.create_UUID(),
            flights: [{ flightNumber: '', flightDate: '', originLabel: '', destinLabel: '', formattedDate: '' }]
        };
    };
    __decorate([
        MapState('bookingValidation')
    ], PaymentBaseForm.prototype, "bookingValidation", void 0);
    PaymentBaseForm = __decorate([
        Component({
            mixins: [validationMixin, FormMixin],
            components: {
                FilesUploadSection: FilesUploadSection,
                InputElement: InputElement,
                CheckboxElement: CheckboxElement,
                TitleElement: TitleElement,
                DateSingleElement: DateSingleElement,
                Errors: Errors
            },
            validations: PaymentValidationService.formValidations,
            props: {
                isDefault: {
                    type: Boolean,
                    default: false
                }
            }
        })
    ], PaymentBaseForm);
    return PaymentBaseForm;
}(Vue));
export default PaymentBaseForm;
